import namespace from '../../config/Namespace';

const types = {
  actions: {
    login: 'login',
    loginSuccess: 'loginSuccess',
    logout: 'logout',
    logoutSuccess: 'logoutSuccess',
    signIn: 'signIn',
    signInSuccess: 'signInSuccess',
    authMfa: 'authMfa',
    authMfaSuccess: 'authMfaSuccess',
    activateMfa: 'activateMfa',
    activateMfaSuccess: 'activateMfaSuccess',
    forgotPass: 'forgotPass',
    forgotPassSuccess: 'forgotPassSuccess',
    resetPass: 'resetPass',
    resetPassSuccess: 'resetPassSuccess',
    resetMFA: 'resetMFA',
    resetMFASuccess: 'resetMFASuccess',
    updateLocalUserData: 'updateLocalUserData',
    switchContext: 'switchContext',
    switchContextSuccess: 'switchContextSuccess',
  },
};

export default namespace('auth', types);
